import type { ReactElement, FC } from 'react'
import React from 'react'

import { getDataSelector } from '@vfuk/core-base-props'
import { useLocalTheme } from '@vfuk/core-themes'

import defaultTheme from './themes/SimpleBadge.theme'
import * as Styled from './styles/SimpleBadge.style'

import type { SimpleBadgeProps } from './SimpleBadge.types'

const SimpleBadge: FC<SimpleBadgeProps> = ({
  appearance = 'primary',
  state,
  localTheme,
  id,
  dataAttributes,
  dataSelectorPrefix,
}: SimpleBadgeProps): ReactElement => {
  const componentName = 'SimpleBadge'
  const simpleBadgeTheme = useLocalTheme(componentName, defaultTheme, localTheme)

  return (
    <Styled.SimpleBadge
      simpleBadgeTheme={simpleBadgeTheme}
      appearance={appearance}
      state={state}
      id={id}
      {...dataAttributes}
      data-selector={getDataSelector(dataSelectorPrefix)}
      data-component-name={componentName}
    />
  )
}

export default SimpleBadge
